<template>
  <div class="flex-box pl5 pr5 mb10 al-c" :style="compWidth()">
    <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
    <div class="flex-1">
      <el-select class="w100" v-model="value" value-key="value" @change="changeValue" :placeholder="typeData.placeholder ? typeData.placeholder : '请选择'">
        <el-option v-for="(val, key) in typeData.data" :key="key" :label="val.label" :value="val"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "CascaderSelectComp",
  props: ["type-data", "step-key", "width", "colspan"],
  components: {},
  data() {
    return {
      value: null
    };
  },
  created() {
    if (this.typeData.value || this.typeData.value == "") {
      for (const item of this.typeData.data) {
        if (item.value == this.typeData.value) {
          this.value = item;
          this.changeValue(item);
          break;
        }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    changeValue(value) {
      // console.log(value);
      this.$emit(
        "change-child",
        value.value,
        this.stepKey,
        value.hasChild ? true : false
      );
    },
    compWidth() {
      if (this.colspan) {
        if (typeof this.colspan == "number") {
          return { width: this.colspan + "px" };
        } else {
          return { width: this.colspan };
        }
      } else {
        return { width: "33%" };
      }
    }
  },
  watch: {
    // 'typeData.data': {
    //     handler(value) {
    //         this.value = null;
    //     },
    //     deep: true
    // }
  }
};
</script>
